export default __webpack_public_path__ + "static/media/logo-tradition-padded.bc07bf89.svg";